import React, { useRef, useState } from "react";
import { Modal, Box, Button } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { toast } from "react-toastify";
import axios from "api/baseurl";
import { useNavigate } from "react-router-dom";
 
const VPAAS_APP_ID =
  "vpaas-magic-cookie-b647a8f66b7c44e0a4e00d21d3df21ef";
const DoctorVideoCallModal = ({ open, roomName, userName, onClose, doctorId, patientId }) => {
  const containerRef = useRef(null);
  const apiRef = useRef(null);
  const [callStarted, setCallStarted] = useState(false);
  const [loading, setLoading] = useState(false);
  const currentDateTime = new Date().toISOString();
  const navigate = useNavigate();
  const [jitsiToken, setJitsiToken] = useState(null);
   const [isModerator, setIsModerator] = useState(false); // <-- new state
  const [callId, setCallId] = useState(null);
 
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
 
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
 
      const date = new Date();
      let day = date.getDate().toString().padStart(2, "0");
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let year = date.getFullYear();
      let currentDate = `${year}-${month}-${day}`;
 
      const rawPayload = {
        doctorId: doctorId,
        patientId: patientId,
        callerName: userName,
        roomName: roomName,
 
        callType: "VIDEO_CALL"
      };
 
      const encryptedData = encryptBody(rawPayload, secretKey);
 
      const response = await axios.post(
        "/api/Doctorcall/initiate",
        encryptedData,
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );
 
      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        toast.success(decrypted?.message || "Video Call Started!");
        setCallId(decrypted.callId);  
    setIsModerator(decrypted?.moderator || false);
      setJitsiToken(decrypted.jitsiToken); 
        startJitsiCall(decrypted.jitsiToken);
        

        // startJitsiCall();
      }
    } catch (err) {
      console.error("Error starting video call:", err);
 
      const backendMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Unable to start the video call at this time.";
 
      toast.error(
        <div>
          <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
            Failed to initiate video call
          </div>
          <div style={{ fontSize: "14px" }}>
            {backendMessage}
          </div>
        </div>
      );
 
    } finally {
      setLoading(false);
    }
 
  };
   const endCall = async () => {

    try {

      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const payload = {
        callId: callId
      };

      const encrypted = encryptBody(payload, secretKey);

      await axios.post(
        "/api/Doctorcall/end",
        encrypted,
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${token}`
          }
        }
      );
    navigate(-1);
    } catch (err) {
      console.error("End call error", err);
    }
  };
  const startJitsiCall = () => {
    if (apiRef.current || !containerRef.current || !window.JitsiMeetExternalAPI) {
      return;
    }
 
    apiRef.current = new window.JitsiMeetExternalAPI(
      "8x8.vc", // ✅ MUST be 8x8.vc for JWT moderator to work
      {
        roomName: `${VPAAS_APP_ID}/${roomName}`, // MUST match backend "room" claim
        parentNode: containerRef.current,
 
        jwt: jitsiToken, // 🔥 THIS IS THE KEY FIX
 
       
       configOverwrite: {
        prejoinPageEnabled: false,   // ✅ auto-join
        enableWelcomePage: false,
        requireDisplayName: false,
        disableInviteFunctions: true,
        hideConferenceSubject: true,
        subject: "",
        startWithAudioMuted: false,
        startWithVideoMuted: false,
      },

      interfaceConfigOverwrite: {
        TOOLBAR_ALWAYS_VISIBLE: true,
        TOOLBAR_TIMEOUT: 999999,

        TOOLBAR_BUTTONS: [
          "microphone",
          "camera",
          "hangup",        // ✅ CANCEL BUTTON
          "fullscreen",
          "tileview",
        ],

        SHOW_JITSI_WATERMARK: false,
        SHOW_WATERMARK_FOR_GUESTS: false,
        SHOW_BRAND_WATERMARK: false,
        SHOW_POWERED_BY: false,
        SHOW_ROOM_NAME: false,
      },
    });

    apiRef.current.addEventListener("videoConferenceJoined", () => {
      apiRef.current.executeCommand("subject", ""); // remove Join meeting text
      setCallStarted(true);
    });

   apiRef.current.addEventListener("videoConferenceLeft", async () => {
      await endCall();
      handleClose();
    });

    /* OTHER USER LEFT */

    apiRef.current.addEventListener("participantLeft", () => {
      handleClose();
    });

    /* SAFETY CLOSE */

    apiRef.current.addEventListener("readyToClose", handleClose);
  };

  /* ------------------ CLOSE ------------------ */
  const handleClose = () => {
    apiRef.current?.dispose();
    apiRef.current = null;
    setCallStarted(false);
    setLoading(false);
    onClose();
  };
 
 
  /* ------------------ CLOSE ------------------ */

 
  //   const startJitsiCall  = () => {
  //     if (apiRef.current || !containerRef.current || !window.JitsiMeetExternalAPI) return;
 
  //     apiRef.current = new window.JitsiMeetExternalAPI("meet.jit.si", {
  //       roomName,
  //       parentNode: containerRef.current,
  //       userInfo: { displayName: userName },
  //       configOverwrite: {
  //       startWithAudioMuted: false,
  //       startWithVideoMuted: false,
  //       disableInviteFunctions: true,
  //       enableWelcomePage: false,
  //       prejoinPageEnabled: false,
  //       requireDisplayName: true,
  //     },
 
  //     interfaceConfigOverwrite: {
  //       SHOW_JITSI_WATERMARK: false,
  //       SHOW_WATERMARK_FOR_GUESTS: false,
  //       DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
  //     },
  //   });
 
  //     apiRef.current.addEventListener("videoConferenceJoined", () => {
  //       apiRef.current.executeCommand("toggleLobby", true);
  //     });
 
  //     apiRef.current.addEventListener("readyToClose", handleClose);
  //     setCallStarted(true);
  //   };
 
  /* ------------------ CLOSE ------------------ */
  //   const handleClose = () => {
  //     if (apiRef.current) {
  //       apiRef.current.dispose();
  //       apiRef.current = null;
  //     }
  //     setCallStarted(false);
  //     onClose();
  //   };
 
  return (
 
    <Modal open={open} onClose={handleClose}>
      <Box sx={{ position: "fixed", inset: 0, bgcolor: "black" }}>
        {/* ✅ CARE PRO HEADER */}
        {/* {callStarted && (
          <Box
            sx={{
    position: "absolute",
    top: 0,
    left: "50%",           // center horizontally
    transform: "translateX(-50%)", // shift back to center
    width: "300px",        // set desired width
    height: "56px",
    bgcolor: "#b9d4f8ff",
    zIndex: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // center text inside box
    px: 2,
    color: "#fff",
    fontSize: "18px",
    fontWeight: 600,
    borderRadius: "8px",   // optional: rounded corners
  }}
          >
            Care Pro – Video Call
          </Box>
        )} */}
 
        {loading && (
          <Box
             sx={{
      position: "absolute",
      inset: 0,
      zIndex: 30,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "#000",
      color: "#fff",
    }}
          >
            {/* Spinner */}
           <Box sx={{ display: "flex", gap: "8px" }}>
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: 12,
            height: 12,
            borderRadius: "50%",
            bgcolor: "#1A237E",
            animation: "pulse 1.4s infinite ease-in-out",
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
            </Box>
 
            {/* Text */}
            <Box sx={{ mt: 3, fontSize: "18px", fontWeight: 500 }}>
              Starting your video call…
            </Box>
 
            {/* Keyframes */}
            <style>
              {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
            </style>
          </Box>
        )}
        
        {/* Visible Join Call button */}
        {!callStarted && !loading &&  (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              alignItems: "center",
            }}
          >             <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}

            sx={{
              backgroundColor: "#1A237E", // Google Meet blue
              color: "#ffffff",          // White text
              fontSize: "18px",
              fontWeight: 600,
              padding: "16px 40px",
              borderRadius: "28px",      // pill-style like Meet
              textTransform: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              width: "260px",
              "&:hover": {
                backgroundColor: "#1A237E",
              },
            }}
          >
              {loading ? "Starting Call..." : "Start Video Call"}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleClose();                  // close the modal first
                navigate("/DoctorLoginPatientDetails"); // then navigate
              }} sx={{
                backgroundColor: "#1A237E", // ✅ same color
                color: "#ffffff",
                fontSize: "18px",
                fontWeight: 600,
                padding: "16px 40px",
                borderRadius: "28px",
                textTransform: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                width: "260px",            // ✅ same size
                "&:hover": {
                  backgroundColor: "#1A237E",
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        )}
 
        <div
          ref={containerRef}
          style={{ width: "100%", height: "100%", backgroundColor: "#000" }}
        />
      </Box>
    </Modal>
  );
};
 
export default DoctorVideoCallModal;